import {
  useFormItemAccessibility,
  useFormItemEnabled,
  useInputController,
} from '@framework/form';
import { TreeSelect } from 'antd';
import type { TreeSelectProps } from 'antd/es/tree-select';
import * as React from 'react';

export interface TreeDataOption {
  title: string;
  value: string;
  label: string;
  children?: TreeDataOption[];
}

export interface TreeSelectInputProps extends Omit<TreeSelectProps, 'name'> {
  name: string;
}

/**
 * Input per la selezione di un nodo di un albero.
 */
export function TreeSelectInput(props: TreeSelectInputProps) {
  const { name, ...inputProps } = props;
  const { enabled, layoutEnabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const handleChange = (value: string) => {
    // Se il valore è undefined, allora lo imposto a null (https://react-hook-form.com/docs/useform/register)
    onChange(value ?? null);
  };

  const accessibility = useFormItemAccessibility();

  return (
    <TreeSelect
      allowClear
      treeLine
      size="large"
      disabled={enabled === false || layoutEnabled === false}
      {...accessibility.attributes}
      {...inputProps}
      value={inputProps.value ?? value ?? null}
      ref={ref}
      onChange={handleChange}
      onBlur={onBlur}
    />
  );
}
